import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaArrayNode } from './TypedNode'
import { SchemaArrayModel } from './ViewModel'

export const SchemaArrayPlugin = createSchemaPlugin(
  'Schema.Array',
  SchemaArrayModel,
  SchemaArrayNode
)
